import React from "react";
import { useLocation } from "react-router-dom";
import Parser from "html-react-parser";
import "./TermsCss.css";

const TermPolicy = () => {
  const location = useLocation();
  const previousStates = location.state;
  const item = previousStates?.item;

  return (
    <div style={{ marginTop: 20 }} className="text-center">
      <p style={{ fontSize: 20, fontWeight: 700, color: "black" }}>
        {item?.title}
      </p>
      <div className="html-wrapper">{Parser(item?.description)}</div>
    </div>
  );
};

export default TermPolicy;
